import { BaseFilterDetails } from "../../../../types/filters";
import { BindingStatusFilterValue, LastLogonFilterValues, LocalAccountsFilters, ModeFilterValue } from "../../../../types/LocalAccountsFilters";

export const LAST_LOGON_FILTER_DETAILS: BaseFilterDetails<LocalAccountsFilters> = {
    id: 'lastLogon',
    label: 'Last logon',
    multiple: false,
    searchable: false,
    options: [
        {
            value: LastLogonFilterValues.Last24Hours,
            label: 'Last 24 hours'
        },
        {
            value: LastLogonFilterValues.LastWeek,
            label: 'Last week'
        },
        {
            value: LastLogonFilterValues.LastMonth,
            label: 'Last month'
        },
        {
            value: LastLogonFilterValues.LastThreeMonths,
            label: 'Last 3 months'
        },
        {
            value: LastLogonFilterValues.LastSixMonths,
            label: 'Last 6 months'
        },
        {
            value: LastLogonFilterValues.LastYear,
            label: 'Last year'
        }
    ]
};

export const BINDING_STATUS_FILTER_DETAILS: BaseFilterDetails<LocalAccountsFilters> = {
    id: 'bindingStatus',
    label: 'Binding status',
    multiple: true,
    searchable: false,
    options: [
        {
            value: BindingStatusFilterValue.Bound,
            label: 'Bound'
        },
        {
            value: BindingStatusFilterValue.Unbound,
            label: 'Unbound'
        }
    ]
};

export const MODE_FILTER_DETAILS: BaseFilterDetails<LocalAccountsFilters> = {
    id: 'mode',
    label: 'Status',
    multiple: true,
    searchable: false,
    options: [
        {
            value: ModeFilterValue.Enabled,
            label: 'Enabled'
        },
        {
            value: ModeFilterValue.Disabled,
            label: 'Disabled'
        }
    ]
};
